export default __webpack_public_path__ + "static/media/customer_1.03bf3ac6.png";